<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-title">Liberar pesquisa</div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-10 offset-md-1">
                                <div class="row">
                                    <div class="col-md-12 centered">
                                        <h3>Liberando a pesquisa</h3>
                                        <h5>Escolha uma pesquisa abaixo para liberar para seus colaboradores</h5>
                                    </div>
                                </div>
                                <div class="row mt-5">
                                    <div class="col-4 col-centered" v-for="preMadeResearch in preMadeResearches" :key="preMadeResearch.id">
                                        <button class='btn btn-normal btn-block' @click="selectPreMadeResearch(preMadeResearch)">
                                            {{ preMadeResearch.name }}
                                        </button>
                                    </div>
                                </div>
                                <div class="row mt-5" v-if="preMadeResearch">
                                    <div class="col-md-8 offset-md-2">
                                        <table class='table table-striped table-hover'>
                                            <thead>
                                                <tr>
                                                    <th>
                                                        Pergunta
                                                    </th>
                                                    <th>
                                                        Tipo
                                                    </th>
                                                    <th>
                                                        Dimensão
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="ask in preMadeResearchAsks" :key="ask.id">
                                                    <td>
                                                        {{ ask.title }}
                                                    </td>
                                                    <td>
                                                        {{ ask.type.name }}
                                                    </td>
                                                    <td>
                                                        {{ ask.dimension.name }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="row mt-4" v-if="preMadeResearch">
                                    <div class="col-md-12 centered">
                                        <button
                                            class="btn btn-normal"
                                            @click="confirm"
                                        >Liberar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            preMadeResearches: [],
            preMadeResearch: null,
            scaleOptions: [
                {
                    number: 0,
                    label: 'Não se aplica'
                },
                {
                    number: 1,
                    label: 'Nunca é verdade'
                },
                {
                    number: 2,
                    label: 'Na maioria das vezes não é verdade'
                },
                {
                    number: 3,
                    label: 'Às vezes é verdade, às vezes não'
                },
                {
                    number: 4,
                    label: 'Na maioria das vezes é verdade'
                },
                {
                    number: 5,
                    label: 'Sempre é verdade'
                }
            ],
        };
    },
    methods: {
        makeFormData() {
            const self = this;
            const fd = new FormData();

            fd.append("name", self.preMadeResearch.name);
            fd.append("cycle_id", 1);
            fd.append("apply_start_date", moment().format('YYYY-MM-DD HH:mm:ss'));

            self.preMadeResearchAsks.forEach(ask => {
                fd.append("asks[]", ask.id);
            });

            self.scaleOptions.forEach((scaleOption, index) => {
                fd.append("scale-label-" +  scaleOption.number, scaleOption.label);
            });

            return fd;
        },
        confirm() {
            const self = this;
            const api = self.$store.state.api + "researches/createAndStart";

            const fd = self.makeFormData();

            self.$http
                .post(api, fd)
                .then(response => {
                    const apiStep =
                        self.$store.state.api +
                        "researchfirststeps/stepCompleted";
                    self.$http
                        .post(apiStep, {
                            step: "liberate"
                        })
                        .then(response => {
                            self.$message(
                                "Sucesso",
                                "Pesquisa iniciada com sucesso",
                                "success"
                            );
                            self.$router.push("/");
                        })
                        .catch(error => {
                            self.$message("Erro", error.response.data, "error");
                        });
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        selectPreMadeResearch(preMadeResearch){
            this.preMadeResearch = preMadeResearch
        },
        getPreMadeResearches() {
            const self = this;
            const api = self.$store.state.api + "premaderesearches?with[]=dimensions.asks.dimension&with[]=dimensions.asks.type";
            self.$http
                .get(api)
                .then(response => {
                    self.preMadeResearches = response.data.data;
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        }
    },
    computed: {
        preMadeResearchAsks(){
            let preMadeResearchAsks = []
            
            if(this.preMadeResearch){
                this.preMadeResearch.dimensions.forEach(dimension => {
                    preMadeResearchAsks = [...preMadeResearchAsks, ...dimension.asks]
                });
            }

            return preMadeResearchAsks
        }
    },
    mounted() {
        this.getPreMadeResearches();
    }
};
</script>


// WEBPACK FOOTER //
// src/components/FirstSteps/Liberate.vue